import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":" history-setting"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21 18.5001C21 19.8808 19.8807 21.0001 18.5 21.0001C17.1193 21.0001 16 19.8808 16 18.5001C16 17.1194 17.1193 16.0001 18.5 16.0001C19.8807 16.0001 21 17.1194 21 18.5001Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21.5 12C21.5 6.7533 17.2467 2.5 12 2.5C10.3719 2.5 8.8394 2.90957 7.5 3.63131C5.69871 4.60193 4.24661 6.13714 3.38065 8M12 7V12L13.25 13.25M11.9998 21.5C7.09079 21.5 3.05145 17.7767 2.55176 13M2.5 3.5V8.5H7.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M18.4999 16.0001C17.1192 16.0001 15.9999 17.1194 15.9999 18.5001C15.9999 19.8808 17.1192 21.0001 18.4999 21.0001C19.8806 21.0001 20.9999 19.8808 20.9999 18.5001C20.9999 17.1194 19.8806 16.0001 18.4999 16.0001ZM18.4999 16.0001V15.0046M18.4999 22.0001V21.0046M16.3328 17.2513L15.4708 16.7536M21.529 20.2513L20.6669 19.7536M20.6669 17.2512L21.5289 16.7535M15.4707 20.2512L16.3328 19.7535","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const HistorySetting = Vue.extend<IconProps>({
  name: 'HistorySettingIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'history-setting',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default HistorySetting;
